import { render, staticRenderFns } from "./UploadDocument.vue?vue&type=template&id=bcbec5dc&scoped=true&"
import script from "./UploadDocument.vue?vue&type=script&lang=js&"
export * from "./UploadDocument.vue?vue&type=script&lang=js&"
import style0 from "./UploadDocument.vue?vue&type=style&index=0&id=bcbec5dc&scoped=true&lang=css&"
import style1 from "./UploadDocument.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbec5dc",
  null
  
)

export default component.exports